import React from 'react';
import { ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Text } from 'src/components/Typography';
import { Group } from 'src/components/Group';
import { GroupHeader } from 'src/components/GroupHeader';
import { Cell, CellIcon } from 'src/components/Cell';
import { Separator } from 'src/components/Separator';
import ProfileIcon from 'src/assets/icons/user.svg';
import BellIcon from 'src/assets/icons/bell.svg';
import SettingsIcon from 'src/assets/icons/settings.svg';

storiesOf('Group', module).add('Default', () => (
  <ScrollView>
    <PanelHeader separator={<Separator line />}>🍭 Group</PanelHeader>
    <Group separator={<Separator line padding />}>
      <Cell
        before={
          <CellIcon>
            <ProfileIcon />
          </CellIcon>
        }
        expandable
      >
        Profile
      </Cell>
      <Cell
        before={
          <CellIcon>
            <BellIcon />
          </CellIcon>
        }
        expandable
      >
        Notifications
      </Cell>
      <Cell
        before={
          <CellIcon>
            <SettingsIcon />
          </CellIcon>
        }
        expandable
      >
        Preferences
      </Cell>
    </Group>
    <Group header={<GroupHeader>Group header</GroupHeader>} separator={false}>
      <Cell
        before={
          <CellIcon>
            <ProfileIcon />
          </CellIcon>
        }
        expandable
      >
        Profile
      </Cell>
      <Cell
        before={
          <CellIcon>
            <BellIcon />
          </CellIcon>
        }
        expandable
      >
        Notifications
      </Cell>
      <Cell
        before={
          <CellIcon>
            <SettingsIcon />
          </CellIcon>
        }
        expandable
      >
        Preferences
      </Cell>
    </Group>
  </ScrollView>
));
